import { render, staticRenderFns } from "./LessonsList.vue?vue&type=template&id=37289395&scoped=true"
import script from "./LessonsList.vue?vue&type=script&lang=js"
export * from "./LessonsList.vue?vue&type=script&lang=js"
import style0 from "./LessonsList.vue?vue&type=style&index=0&id=37289395&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37289395",
  null
  
)

export default component.exports